export enum ProductsResultsColumn {
  Lender = 1,
  ProductDescription = 2,
  ProductCode = 3,
  ProductType = 4,
  MaxLtv = 5,
  InitialPeriod = 6,
  InitialRate = 7,
  RateType = 8,
  RevertRate = 9,
  InitialMonthlyPayment = 10,
  MonthlyPaymentRevert = 11,
  TrueCostInitialPeriod = 12,
  TrueCostCustomPeriod = 13,
  TrueCostTerm = 14,
  OutstandingBalance = 15,
  Erc = 16,
  Cashback = 17,
  TotalFees = 18,
  Criteria = 19,
  AffordabilityMet = 20,
  MaxDuration = 21,
  MonthlyRate = 22,
  MonthlyPayment = 23,
  GrossLoan = 24,
  GrossLtv = 25,
  ExitFee = 26,
  Aprc = 27,
  Compare = 28,
  Docs = 29,
  ArrangementFee = 30,
  MaxAffordableLoan = 31,
  RentalRequired = 32,
  Withdrawing = 33,
  FreeLegal = 34,
  OverpaymentsAllowed = 35,
}

export interface ProductResultsConfigurationColumnRequestModel {
  column: ProductsResultsColumn;
  isVisible: boolean;
}

export enum ProductResultsOrderDirection {
  Asc = 1,
  Desc = 2,
}

export interface ProductResultsOrder {
  sortOn: ProductsResultsColumn;
  sortDir: ProductResultsOrderDirection;
}

export interface ProductResultsConfigurationRequestModel {
  columns: ProductResultsConfigurationColumnRequestModel[];
  productResultsOrder: ProductResultsOrder | null;
}

export interface ProductResultsConfigurationColumnResponseModel {
  column: ProductsResultsColumn;
  isVisible: boolean;
  canBeHidden: boolean;
  canBeHiddenDistributionGroup: string | null;
}

export interface ProductResultsConfigurationResponseModel {
  columns: ProductResultsConfigurationColumnResponseModel[];
  productResultsOrder: ProductResultsOrder | null;
}

export interface DistributionGroupProductResultsConfigurationColumnRequestModel {
  column: ProductsResultsColumn;
  isDefault: boolean;
  canBeOverriddenByBroker: boolean;
  canBeHidden: boolean;
}

export interface DistributionGroupProductResultsConfigurationRequestModel {
  columns: DistributionGroupProductResultsConfigurationColumnRequestModel[];
}

export interface DistributionGroupProductResultsConfigurationLocalModel {
  isUpdated: boolean;
  model: DistributionGroupProductResultsConfigurationRequestModel;
}
